export default __webpack_public_path__ + "static/above-ground-pool-removal-icon-309447156b545d346f733a506cbb99e3.png";